import React, { useContext, useState, useEffect, useRef } from "react";
import { MultiSelect } from "react-multi-select-component";
import {
  Box,
  Button,
  Center,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Grid,
  VStack,
  useToast,
  useDisclosure,
  Input,
  Select,
  Flex,
  HStack,
  CheckboxGroup,
  Stack,
  Checkbox,
  Tag,
  TagLabel,
  TagCloseButton,
  FormControl,
  FormLabel,
  Wrap,
  SimpleGrid,
  IconButton,
} from "@chakra-ui/react";
import Navbar from "../../Components/Navbar";
import { MateriaContext } from "../../contexts/Materia";
import MeuEditor from "../../Components/Editor/CKeditor";
import MeuTinyEditor from "../../Components/Editor/editor";
import { EditIcon } from "@chakra-ui/icons";
const MateriaPage = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const roleId = user?.role_id;
  const toast = useToast();
  const {
    DetailMateriaApi,
    createRespostaQuestaoApi,
    deleteRespostaQuestoesApi,
    createQuestaoApi,
    deleteQuestionApi,
    updateQuestionApi,
    createSubjectApi,
    listSubjectsApi,
    deleteSubjectApi,
    updateSubjectApi,
    getQuestionApi,
    countQuestionsApi,
  } = useContext(MateriaContext);
  const [materia, setMateria] = useState();
  const [isQuestionEditing, setIsQuestionEditing] = useState(false);
  const [editedQuestion, setEditedQuestion] = useState("");
  const [countQuestion, setCountQuestion] = useState("");
  const [visibleCount, setVisibleCount] = useState(10);
  const {
    isOpen: isAnswerModalOpen,
    onOpen: onAnswerModalOpen,
    onClose: onAnswerModalClose,
  } = useDisclosure();
  const {
    isOpen: isQuestionModalOpen,
    onOpen: onQuestionModalOpen,
    onClose: onQuestionModalClose,
  } = useDisclosure();

  const [newAnswer, setNewAnswer] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [newQuestion, setNewQuestion] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQuestionBoxOpen, setIsQuestionBoxOpen] = useState(false);
  const [isSubjectBoxOpen, setIsSubjectBoxOpen] = useState(false);
  const [questionID, setQuestionID] = useState();
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState();
  const [subjectQuestion, setSubjectQuestion] = useState();
  const [updateSubject, setUpdateSubject] = useState();
  const [secondarySubjects, setSecondarySubjects] = useState([]);
  const [checkQuestion, setCheckQuestion] = useState();
  const [answers, setAnswers] = useState([
    { answer: "", answer_verify: false },
  ]);
  const [editDifficulty, setEditDifficulty] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentSubject, setCurrentSubject] = useState({ id: null, name: "" });

  const [subjectQuestionCheck, setsubjectQuestionCheck] = useState(null);
  const [selectedSecondarySubjects, setSelectedSecondarySubjects] = useState(
    []
  );

  const openEditModal = (subject) => {
    setCurrentSubject({ id: subject.id, name: subject.subject });
    setIsEditing(true);
  };

  const handleSave = async () => {
    const data = {
      subject: currentSubject.name,
    };
    try {
      await updateSubjectApi(currentSubject.id, data);
      toast({
        title: "Assunto atualizado com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      getAssuntosMateria();
      setIsEditing(false);
    } catch (error) {
      toast({
        title: "Erro ao atualizar assunto",
        status: "error",
        isClosable: true,
      });
    }
  };

  const openModal = (question) => {
    fetchQuestionData(question.id);
    setQuestionID(question.id);
    setIsModalOpen(true);
  };
  const fetchQuestionData = async (questionID) => {
    try {
      const response = await getQuestionApi(questionID);
      if (response.status === 200) {
        const questionData = response.data.question;
        setEditedQuestion(questionData?.question);
        setsubjectQuestionCheck(questionData?.subject_id);
        setUpdateSubject(questionData?.subject_id);
        setEditDifficulty(questionData?.difficulty);
        setCheckQuestion(questionData);
      }
    } catch (error) {
      console.error("Erro ao buscar dados da questão:", error);
    }
  };

  const countQuestions = async () => {
    const materiaID = localStorage.getItem("matery_id");
    try {
      const responseCountQuestion = await countQuestionsApi(materiaID);
      if (responseCountQuestion.status === 200) {
        const countResponse = responseCountQuestion.data[0];

        setCountQuestion(countResponse);
      }
    } catch (error) {
      console.error("Erro ao buscar dados da questão:", error);
    }
  };

  const handleAddAnswerQuestion = () => {
    setAnswers([...answers, { answer: "", answer_verify: false }]);
  };

  const handleAnswerChange = (index, field, value) => {
    const updatedAnswers = [...answers];

    // Se o campo for "answer_verify" e a resposta for marcada como correta
    if (field === "answer_verify" && value === true) {
      // Desmarcar todas as outras respostas
      updatedAnswers.forEach((answer, i) => {
        if (i !== index) {
          answer.answer_verify = false;
        }
      });
    }

    // Atualiza o valor da resposta
    updatedAnswers[index][field] = value;

    setAnswers(updatedAnswers);
  };

  const handleRemoveAnswer = (index) => {
    setAnswers(answers.filter((_, i) => i !== index));
  };
  const timeoutRef = useRef(null);

  const handleSecondarySubjects = (selectedOptions) => {
    setSecondarySubjects(selectedOptions);
  };

  async function getMateriaInfo() {
    const materiaID = localStorage.getItem("matery_id");
    try {
      const materiaInfoApi = await DetailMateriaApi(materiaID);
      console.log(materiaInfoApi.data);
      setMateria(materiaInfoApi.data);
    } catch (error) {
      console.log(error);
    }

    countQuestions();
  }

  async function getAssuntosMateria() {
    const materiaID = localStorage.getItem("matery_id");
    try {
      const subjectsApi = await listSubjectsApi(materiaID);
      console.log(subjectsApi.data?.[0]);
      setSubjects(subjectsApi.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getMateriaInfo();
    getAssuntosMateria();
  }, []);

  const handleAddAnswer = async () => {
    if (!selectedQuestion) return;

    // Verificar se já existe uma resposta correta
    const hasCorrectAnswer = selectedQuestion.answers.some(
      (answer) => answer.answer_verify === 1
    );

    if (isCorrect && hasCorrectAnswer) {
      // Exibir mensagem de erro ao usuário
      alert("Já existe uma resposta correta para essa questão!");
      return;
    }

    const newAnswerObj = {
      question_id: selectedQuestion.id,
      answer: newAnswer,
      is_correct: isCorrect ? 1 : 0,
    };

    // Chamar a função para adicionar a resposta via API ou atualizar o estado
    try {
      const answerInfoApi = await createRespostaQuestaoApi(newAnswerObj);
      console.log(answerInfoApi);

      if (answerInfoApi.status === 200) {
        toast({
          title: "Resposta adicionada com Sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
      console.log(error);
      // Exibir mensagem de erro ao usuário, se necessário
    }

    setNewAnswer("");
    setIsCorrect(false);
    setSelectedQuestion(null);
    onAnswerModalClose();
    getMateriaInfo();
  };

  const deleteResposta = async (id) => {
    try {
      const deleteResposta = await deleteRespostaQuestoesApi(id);
      console.log(deleteResposta.data);
      if (deleteResposta.status === 200) {
        toast({
          title: "Resposta deletada com Sucesso",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }
    getMateriaInfo();
  };

  const handleChangeDifficulty = (value) => {
    setDifficulty(value);
  };

  const handleSubjectQuestion = (value) => {
    setSubjectQuestion(value);
  };
  const validateAnswers = () => {
    const correctAnswers = answers.filter((answer) => answer.answer_verify);
    if (correctAnswers.length !== 1) {
      alert("Apenas uma resposta correta pode ser selecionada.");
      return false;
    }
    return true;
  };
  const handleAddQuestion = async () => {
    if (!validateAnswers()) {
      return;
    }
    const materiaID = localStorage.getItem("matery_id");
    const data = {
      matery_id: materiaID,
      difficulty: difficulty,
      question: newQuestion,
      subject_id: subjectQuestion,
      materies: secondarySubjects.map((subject) => subject.value),
      answers: answers,
    };
    try {
      const createQuestion = await createQuestaoApi(data);
      if (createQuestion.status === 200) {
        toast({
          title: "Questão adicionada com Sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }

    setNewQuestion("");
    setIsQuestionBoxOpen(false);
    getMateriaInfo();
    handleSubjectQuestion(null);
    setSelectedSecondarySubjects([]);
    setSecondarySubjects([]);
    setDifficulty("");
    setSubjectQuestion("");
    setAnswers([{ answer: "", answer_verify: false }]);
  };

  const handleAddSubject = async () => {
    const materiaID = localStorage.getItem("matery_id");
    const data = {
      matery_id: materiaID,
      subject: subject,
    };
    try {
      const response = await createSubjectApi(data);
      if (response.status === 200) {
        toast({
          title: "Assunto adicionada com Sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }
    // Reset the newQuestion state after submitting
    setSubject("");
    setIsSubjectBoxOpen(false);
    getAssuntosMateria();
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChangeNewQuestion = (value) => {
    setNewQuestion(value);
  };

  const handleChangeNewAnswer = (value) => {
    setNewAnswer(value);
    // Atraso de 800 milissegundos (ajuste conforme necessário)
  };
  // Função para lidar com a alteração no JoditEditor
  const handleChange = (value) => {
    setEditedQuestion(value);
    // Atraso de 800 milissegundos (ajuste conforme necessário)
  };
  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  const handleUpdateQuestion = async () => {
    const data = {
      question: editedQuestion,
      subject_id: updateSubject,
      secondary_subjects: selectedSecondarySubjects,
      difficulty: editDifficulty,
    };

    try {
      const updateQuestionResponse = await updateQuestionApi(questionID, data);
      console.log(updateQuestionResponse);

      if (updateQuestionResponse.status === 200) {
        toast({
          title: "Questão atualizada com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Algo deu errado",
        description: "Não foi possível atualizar a questão. Tente novamente.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error("Erro ao atualizar questão:", error);
    }

    await getMateriaInfo();
    closeModal();
  };

  const deleteQuestion = async (id) => {
    try {
      const deleteQuestion = await deleteQuestionApi(id);

      if (deleteQuestion.status === 200) {
        toast({
          title: "Questão deletada com Sucesso",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }
    getMateriaInfo();
  };

  const deleteSubject = async (id) => {
    try {
      const deleteSubject = await deleteSubjectApi(id);
      if (deleteSubject.status === 200) {
        toast({
          title: "Assunto deletada com Sucesso",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }
    getAssuntosMateria();
  };

  return (
    <>
      <Navbar />
      {materia && (
        <Box
          p={8}
          ml={{ base: 0, md: 60 }}
          bgColor={"#f0f8ff"}
          minH={"100vh"}
          mt={"-35px"}
        >
          <Flex justifyContent="space-between">
            <Box>
              <Heading as="h1" size="xl" mb={4}>
                {materia.matery?.matery}
              </Heading>

              <Text fontWeight={"bold"}>
                Quantidade de questões: {" " + countQuestion}
              </Text>
            </Box>
            <Box>
              <Button
                colorScheme="teal"
                mr={3}
                onClick={() => setIsQuestionBoxOpen(true)}
              >
                Adicionar nova questão
              </Button>
              <Button
                colorScheme="blue"
                onClick={() => setIsSubjectBoxOpen(true)}
              >
                Adicionar Assunto
              </Button>
            </Box>
          </Flex>
          {subjects && (
            <Box my={5}>
              <Text>Lista de assuntos da matéria</Text>
              <Wrap spacing={4}>
                {subjects.map((subject, index) => (
                  <>
                    <Tag
                      key={index}
                      borderRadius="full"
                      variant="solid"
                      colorScheme="green"
                    >
                      {roleId === 1 && (
                        <EditIcon
                          mr={2}
                          onClick={() => openEditModal(subject)}
                        />
                      )}
                      <TagLabel>{subject.subject}</TagLabel>

                      {roleId === 1 && (
                        <>
                          <TagCloseButton
                            onClick={() => deleteSubject(subject.id)}
                          />
                        </>
                      )}
                    </Tag>
                  </>
                ))}
              </Wrap>
            </Box>
          )}

          {isQuestionBoxOpen && (
            <Box
              borderWidth="1px"
              borderRadius="md"
              p={4}
              bg="white"
              boxShadow="md"
              mb={5}
              display="flex"
              flexDirection="column"
            >
              {/* Seleção de Dificuldade */}
              <Select
                my={5}
                placeholder="Selecione a dificuldade"
                required
                onChange={(e) => handleChangeDifficulty(e.target.value)}
              >
                <option value="1">Iniciante</option>
                <option value="2">Intermediário</option>
                <option value="3">Avançado</option>
              </Select>

              {/* Seleção de Assunto Principal */}
              <Text>Selecione o assunto principal da questão</Text>
              <Select
                mb={5}
                required
                value={subjectQuestion}
                placeholder="Selecionar assunto principal"
                onChange={(e) => handleSubjectQuestion(e.target.value)}
              >
                {subjects &&
                  subjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subject}
                    </option>
                  ))}
              </Select>

              {/* Seleção de Assuntos Secundários */}
              <Text>Selecione os assuntos secundários</Text>
              <style>{`
      .rmsc .dropdown-content {
        z-index: 99999 !important;
      }
    `}</style>
              <MultiSelect
                my={5}
                options={subjects.map((subject) => ({
                  label: subject.subject,
                  value: subject.id,
                }))}
                value={secondarySubjects}
                onChange={setSecondarySubjects}
                labelledBy="Selecione os assuntos secundários"
                overrideStrings={{
                  allItemsAreSelected: "Todos os assuntos foram selecionados",
                  selectSomeItems: "Selecione os assuntos",
                  search: "Pesquisar",
                }}
                style={{ zIndex: 99999 }}
              />

              <Box marginBottom={5}></Box>
              {/* Editor de Questão */}
              <MeuTinyEditor
                zIndex={-1}
                value={newQuestion ?? " "}
                onChange={(e) => handleChangeNewQuestion(e)}
              />
              {/* <MeuEditor
                mt={5}
                my={5}
                value={newQuestion ?? " "}
                onChange={(e) => handleChangeNewQuestion(e)}
              /> */}

              {/* Adicionando Respostas */}
              <Text py={5}>Adicione as respostas da questão</Text>
              {answers.map((answer, index) => (
                <Box key={index} mb={3}>
                  <MeuTinyEditor
                    zIndex={0}
                    value={answer.answer ?? " "}
                    onChange={(content) =>
                      handleAnswerChange(index, "answer", content)
                    }
                  />
                  <Checkbox
                    mt={1}
                    mr={5}
                    isChecked={answer.answer_verify}
                    onChange={(e) =>
                      handleAnswerChange(
                        index,
                        "answer_verify",
                        e.target.checked
                      )
                    }
                  >
                    Esta é a resposta correta
                  </Checkbox>
                  <Button
                    mt={1}
                    colorScheme="red"
                    size="sm"
                    onClick={() => handleRemoveAnswer(index)}
                  >
                    Remover
                  </Button>
                </Box>
              ))}

              <Button
                colorScheme="blue"
                size="sm"
                my={5}
                width="20%"
                onClick={handleAddAnswerQuestion}
              >
                Adicionar Resposta
              </Button>

              <Box display={"flex"}>
                {/* Botões */}
                <Button
                  colorScheme="teal"
                  onClick={handleAddQuestion}
                  mt={5}
                  width="30%"
                >
                  Salvar Questão
                </Button>
                <Button
                  ml={2}
                  colorScheme="red"
                  onClick={() => setIsQuestionBoxOpen(false)}
                  mt={5}
                  width="20%"
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          )}

          {isSubjectBoxOpen && (
            <Box
              borderWidth="1px"
              borderRadius="md"
              p={4}
              bg="white"
              boxShadow="md"
              mb={5}
            >
              <FormControl>
                <FormLabel>Digite o Assunto</FormLabel>
                <Input onChange={(e) => setSubject(e.target.value)} />
              </FormControl>
              <Button colorScheme="teal" onClick={handleAddSubject} mt={5}>
                Salvar Assunto
              </Button>
              <Button
                ml={2}
                colorScheme="red"
                onClick={() => setIsSubjectBoxOpen(false)}
                mt={5}
              >
                Cancelar
              </Button>
            </Box>
          )}
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
            gap={4}
          >
            {materia.matery?.questions
              ?.slice(0, visibleCount)
              .map((question) => (
                <Box
                  key={question.id}
                  borderWidth="1px"
                  borderRadius="md"
                  p={4}
                  bg="white"
                  boxShadow="md"
                >
                  <Text fontSize={"18px"} fontWeight={"bold"} py={5}>
                    Dificuldade:
                    {question.difficulty === 1
                      ? " Iniciante"
                      : question.difficulty === 2
                      ? " Intermediário"
                      : question.difficulty === 3
                      ? " Avançado"
                      : ""}
                  </Text>
                  {question.subject && (
                    <Text fontSize={"16px"} fontWeight={"bold"} py={5}>
                      Assunto principal: {question.subject.subject}
                    </Text>
                  )}

                  {question.secondary_subjects?.length > 0 && (
                    <Box>
                      <Text fontSize={"16px"} fontWeight={"bold"}>
                        Assuntos Secundários:
                      </Text>
                      <Box display="inline-flex" flexWrap="wrap" gap="10px">
                        {question.secondary_subjects.map((secSubject) => (
                          <Text key={secSubject.id} fontSize="14px">
                            {secSubject.subject}
                          </Text>
                        ))}
                      </Box>
                    </Box>
                  )}
                  <Box fontSize="md" mb={2} pt={5}>
                    <Text fontSize={"16px"} fontWeight={"bold"}>
                      Descrição da questão:{" "}
                    </Text>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: isQuestionEditing
                          ? editedQuestion
                          : question.question,
                      }}
                    />
                  </Box>
                  {question.answers.map((answer, index) => (
                    <Box
                      key={answer.id}
                      p={2}
                      borderBottom={"1px solid #e9e9e9"}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box display={"inline-flex"}>
                        <Text fontWeight={"bold"}>
                          ({String.fromCharCode(65 + index)})
                        </Text>
                        <Box ml={5}>
                          <span
                            ml={5}
                            dangerouslySetInnerHTML={{
                              __html: answer.answer,
                            }}
                          />
                        </Box>
                      </Box>

                      {answer.answer_verify === 1 ? (
                        <Text color="green.500">Resposta correta</Text>
                      ) : (
                        <Text color="red.500">Resposta incorreta</Text>
                      )}
                      <Button
                        size="sm"
                        mt={3}
                        colorScheme="red"
                        onClick={() => deleteResposta(answer.id)}
                      >
                        Excluir
                      </Button>
                    </Box>
                  ))}
                  <Center>
                    <Button
                      mt={4}
                      colorScheme="teal"
                      onClick={() => {
                        setSelectedQuestion(question);
                        onAnswerModalOpen();
                      }}
                    >
                      Adicionar Resposta
                    </Button>
                    <Button mt={4} ml={5} onClick={() => openModal(question)}>
                      Editar Questão
                    </Button>
                    <Button
                      mt={4}
                      ml={5}
                      colorScheme="red"
                      onClick={() => deleteQuestion(question.id)}
                    >
                      Excluir Questão
                    </Button>
                  </Center>
                </Box>
              ))}

            {visibleCount < materia.matery?.questions?.length && (
              <Center mt={4}>
                <Button onClick={handleLoadMore}>Carregar mais</Button>
              </Center>
            )}
          </Grid>
        </Box>
      )}

      {/** Modal criar questao */}

      {selectedQuestion && (
        <Modal isOpen={isAnswerModalOpen} onClose={onAnswerModalClose}>
          <ModalOverlay />
          <ModalContent width={"1000px"} maxW={"90%"}>
            <ModalHeader>Adicionar Resposta</ModalHeader>
            <ModalBody>
              <VStack spacing={4} align="stretch">
                <Text>Resposta:</Text>
                <MeuTinyEditor
                  value={newAnswer ?? " "}
                  onChange={(value) => handleChangeNewAnswer(value)}
                />
                <Text>Verdadeiro ou Falso:</Text>
                <Select
                  value={isCorrect ? "true" : "false"}
                  onChange={(e) => setIsCorrect(e.target.value === "true")}
                >
                  <option value="true">Verdadeiro</option>
                  <option value="false">Falso</option>
                </Select>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="teal" mr={3} onClick={handleAddAnswer}>
                Adicionar
              </Button>
              <Button onClick={onAnswerModalClose}>Cancelar</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      <Modal isOpen={isQuestionModalOpen} onClose={onQuestionModalClose}>
        <ModalOverlay />
        <ModalContent width={"900px"} maxW={"90%"}>
          <ModalHeader>Adicionar Questão</ModalHeader>
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Select
                placeholder="Selecione a dificuldade"
                required
                onChange={(e) => handleChangeDifficulty(e.target.value)}
              >
                <option value="1">Iniciante</option>
                <option value="2">Intermediário</option>
                <option value="3">Avançado</option>
              </Select>
              <Text>Questão:</Text>
              <MeuTinyEditor
                value={newQuestion ?? " "}
                onChange={(value) => handleChangeNewQuestion(value)}
              />
              {/* <MeuEditor
                value={newQuestion ?? " "}
                onChange={(value) => handleChangeNewQuestion(value)}
              /> */}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} onClick={handleAddQuestion}>
              Adicionar
            </Button>
            <Button onClick={() => onQuestionModalClose()}>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {subjects && subjects?.length > 0 && (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <ModalOverlay />
          <ModalContent width={"1000px"} maxW={"90%"}>
            <ModalHeader>Editar Questão</ModalHeader>
            <ModalBody>
              <Text my={2}>Selecione a dificuldade da questão</Text>
              <Select
                mb={5}
                placeholder="Selecione a dificuldade"
                value={editDifficulty}
                onChange={(e) => setEditDifficulty(e.target.value)}
              >
                <option value="1">Iniciante</option>
                <option value="2">Intermediário</option>
                <option value="3">Avançado</option>
              </Select>
              <Text>Selecione o assunto principal da questão</Text>
              <Select
                mb={5}
                required
                placeholder="Selecionar assunto principal"
                value={updateSubject}
                onChange={(e) => setUpdateSubject(e.target.value)}
              >
                {subjects.map((subject) => (
                  <option key={subject.id} value={subject.id}>
                    {subject.subject}
                  </option>
                ))}
              </Select>

              <Text>Assuntos Secundários Selecionados:</Text>

              <Box display="inline-flex" flexWrap="wrap" gap="10px">
                {checkQuestion?.secondary_subjects?.map((subject) => (
                  <Text fontSize="14px" color={"black"} key={subject.id}>
                    {subject?.subject}
                  </Text>
                ))}
              </Box>
              <Box my={5}></Box>
              <Text>Selecione os assuntos secundários da questão</Text>

              <MultiSelect
                options={subjects.map((subject) => ({
                  label: subject.subject,
                  value: subject.id,
                }))}
                value={selectedSecondarySubjects} // Aqui ele estará vazio
                onChange={setSelectedSecondarySubjects} // Atualiza o valor ao selecionar/desmarcar
                labelledBy="Selecione os assuntos secundários"
                overrideStrings={{
                  allItemsAreSelected: "Todos os assuntos foram selecionados",
                  selectSomeItems: "Selecione os assuntos",
                  search: "Pesquisar",
                }}
              />

              <Box my={5}></Box>

              <MeuTinyEditor
                zIndex={0}
                value={editedQuestion}
                onChange={handleChange}
              />
              {/* <MeuEditor
                initialValue={editedQuestion}
                value={editedQuestion}
                onChange={handleChange}
              /> */}
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="teal"
                onClick={() =>
                  handleUpdateQuestion(
                    subjectQuestionCheck,
                    selectedSecondarySubjects
                  )
                }
              >
                Atualizar
              </Button>
              <Button onClick={closeModal}>Cancelar</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {/* MODAL PARA EDITAR O ASSUNTO */}
      <Modal isOpen={isEditing} onClose={() => setIsEditing(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Editar Assunto</ModalHeader>
          <ModalBody>
            <Input
              value={currentSubject.name}
              onChange={(e) =>
                setCurrentSubject({ ...currentSubject, name: e.target.value })
              }
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" onClick={handleSave}>
              Salvar
            </Button>
            <Button ml={3} onClick={() => setIsEditing(false)}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default MateriaPage;
